module.exports = __webpack_public_path__ + "img/human_64.dbbd7add.png";